import type { App, Component } from 'vue'
import { Menu as VMenu } from 'floating-vue'

// WUK Components
import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue'
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue'
import SwordDropdownWuk from '@ui-kit/components/inputs/dropdowns/SwordDropdown.vue'
import SwordFormattedDateWuk from '@ui-kit/components/inputs/date/SwordFormattedDate.vue'
import InputLabelWuk from '@ui-kit/components/inputs/labels/InputLabel.vue'
import MultipleInputEntriesWuk from '@ui-kit/components/inputs/MultipleInputEntries.vue'
import SwordRadioGroupWuk from '@ui-kit/components/inputs/radios/SwordRadioGroup.vue'
import SwordFileUploadWuk from '@ui-kit/components/inputs/SwordFileUpload.vue'
import SwordTextareaWuk from '@ui-kit/components/inputs/SwordTextarea.vue'
import SwordLinkWuk from '@ui-kit/components/links/SwordLink.vue'
import MenuWuk from '@ui-kit/components/menus/Menu.vue'
import SwordTabWuk from '@ui-kit/components/tab/SwordTab.vue'
import SwordTabGroupWuk from '@ui-kit/components/tab/SwordTabGroup.vue'

// Local/Bridge Components
import SwordList from '@/components/menus/SwordList.vue'
import Pill from '@/components/micro/Pills/BasePill/index.vue'
import HoverToCopy from '@/components/common/HoverToCopy.vue'
import SwordInput from '@/components/common/SwordInput.vue' // Bridge component - Vue 2 v-model to Vue 3 XInput
import SwordToggle from '@/components/common/SwordToggle.vue' // Bridge component - Vue 2 v-model to Vue 3 XToggle
import SwordCheckbox from '@/components/common/SwordCheckbox.vue' // Bridge component - Vue 2 v-model to Vue 3 XCheckbox
import SwordPhone from '@/components/common/SwordPhone.vue' // Bridge component - Vue 2 v-model to Vue 3 XPhone

// UI Components
import {
  XAlert,
  XAvatar,
  XCheckbox,
  XCheckboxGroup,
  XDatepicker,
  XDropdown,
  XInput,
  XLoader,
  XPopover,
  XTag,
  XTooltip,
  XInputGroup,
} from '@swordhealth/ui'

// Set MODE: 3 to prevent compat runtime from remapping `modelValue` → `value` for pre-compiled Vue 3 components.
const VUE3_COMPAT_COMPONENTS = [XInput, XDropdown, XCheckbox, XCheckboxGroup]

VUE3_COMPAT_COMPONENTS.forEach((component) => component.compatConfig = { MODE: 3 })

const wukComponents = {
  'SwordLoader': XLoader,
  'SwordIcon': SwordIconWuk,
  'SwordInputGroup': XInputGroup,
  'SwordInput': SwordInput,
  'SwordButtonWuk': SwordButtonWuk,
  'ProfilePicture': XAvatar,
  'SwordCheckbox': SwordCheckbox,
  'SwordTag': XTag,
  'SwordTooltip': XTooltip,
  'SwordPopoverWuk': XPopover,
  'HoverToCopy': HoverToCopy,
  'SwordDropdownWuk': SwordDropdownWuk,
  'SwordTextareaWuk': SwordTextareaWuk,
  'SwordToggle': SwordToggle,
  'SwordCheckboxGroup': XCheckboxGroup,
  'SwordPasswordWuk': SwordInput,
  'SwordRadioGroupWuk': SwordRadioGroupWuk,
  'SwordPhone': SwordPhone,
  'InputLabelWuk': InputLabelWuk,
  'SwordDate': XDatepicker,
  'SwordFormattedDateWuk': SwordFormattedDateWuk,
  'MultipleInputEntriesWuk': MultipleInputEntriesWuk,
  'SwordFileUploadWuk': SwordFileUploadWuk,
  'SwordAlertWuk': XAlert,
  'MenuWuk': MenuWuk,
  'BasePill': Pill,
  'SwordLink': SwordLinkWuk,
  'SwordTabWuk': SwordTabWuk,
  'SwordTabGroupWuk': SwordTabGroupWuk,
  'SwordList': SwordList,
  'VMenu': VMenu,
}

export default {
  install(app: App) {
    Object.entries(wukComponents).forEach(([name, component]) => {
      app.component(name, component as Component)
    })
  },
}
